import axios from "axios";
import api from "../../api/endpoints";

// const COMMENTS_API = "https://betaapi.jgatenext.com/api/GetArticleComments/";
// const LIKES_API = "https://betaapi.jgatenext.com/api/GetArticleLikes/";

// const COMMENTS_API = `${api.baseApi}/api/GetArticleComments/`;
// const LIKES_API = `${api.baseApi}/api/GetArticleLikes/`;

export async function getNCGDetails(data: any) {
  try {
    const response = await axios.get(
      // `${api.baseApi}/api/indexing/solr/ncg_video_core`,
      `${api.baseApi}/api/indexing/solr/ncgvideocore`,
      {
        params: data,
      },
    );

    return response;
  } catch (error) {
    console.error("Error fetching NCG details:", error);
    throw error;
  }
}

export async function getNCGThumnailDetails() {
  try {
    const response = await axios.get(
      `${api.baseApi}/api/get_thumbnail_by_video_id/?videoId=VTB Library_I_Videos_Case 50`,
    );

    return response;
  } catch (error) {
    console.error("Error fetching NCG details:", error);
    throw error;
  }
}

export async function getNCGVideoDetails() {
  try {
    const response = await axios.get(
      `${api.baseApi}/api/get_video_by_id/?videoId=VTB%20Library_I_Videos_Case%2050`,
    );

    return response;
  } catch (error) {
    console.error("Error fetching NCG details:", error);
    throw error;
  }
}

export async function getArticleLikeById(articleId: any) {
  try {
    const response = await axios.get(
      `${api.baseApi}/api/get_article_like_by_id/get_article_like_by_id?article_id=${articleId}`,
    );

    return response;
  } catch (error) {
    console.error("Error fetching NCG details:", error);
    throw error;
  }
}

export async function getArticleCommentsById(articleId: any) {
  try {
    const response = await axios.get(
      `${api.baseApi}/api/get_article_comments_by_id/get_article_comments_by_id?article_id=${articleId}`,
    );

    return response;
  } catch (error) {
    console.error("Error fetching NCG details:", error);
    throw error;
  }
}

export const getArticleCommentsBulk = async (
  articleIds: (string | number)[],
) => {
  const formData = new FormData();

  formData.append(
    "detailed_json",
    JSON.stringify({
      data: articleIds,
    }),
  );

  const response = await axios.post(
    `${api.baseApi}/api/GetArticleComments/`,
    formData,
  );

  // return axios.post(COMMENTS_API, formData);
  return response;
};

export const getArticleLikesBulk = async (articleIds: (string | number)[]) => {
  const formData = new FormData();

  formData.append(
    "detailed_json",
    JSON.stringify({
      data: articleIds,
    }),
  );

  const response = await axios.post(
    `${api.baseApi}/api/GetArticleLikes/`,
    formData,
  );

  // return axios.post(LIKES_API, formData);
  return response;
};

export const updateNcgVideoUsage = async (data: {
  profile_id: string | number | null;
  customer_id: string | number | null;
  consortia_id: string | number;
  article_id: string | number;
  session_id: string | null;
  duration?: number | null;
}) => {
  try {
    const formData = new FormData();

    formData.append("detailed_json", JSON.stringify(data));

    const response = await axios.post(
      `${api.baseApi}/api/UpdateNcgVideoUsage/`,
      formData,
    );

    return response;
  } catch (error) {
    console.error("Error updating NCG video usage:", error);
    throw error;
  }
};
